module.exports = __webpack_public_path__ + "static/media/Weber_logo.7ed72ed0.svg";